import { render, staticRenderFns } from "./buyerList.vue?vue&type=template&id=8de5146c&scoped=true"
import script from "./buyerList.vue?vue&type=script&lang=js"
export * from "./buyerList.vue?vue&type=script&lang=js"
import style0 from "./buyerList.vue?vue&type=style&index=0&id=8de5146c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de5146c",
  null
  
)

export default component.exports